import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useBuilder } from '../../contexts/BuilderContext';
import { injectIntl } from 'react-intl';

// 이 컴포넌트는 더 이상 직접 폼을 렌더링하지 않습니다.
// 대신 "편집 버튼"을 보여주고, 클릭 시 BuilderContext를 통해 사이드바를 활성화합니다.

const EditButtonContainer = styled.div`
  position: absolute;
  top: 10px;
  left: 10px;
  z-index: 100;

  button {
    font-size: 12px;
    padding: 8px 16px;
    opacity: 0.9;
    box-shadow: 0 2px 8px rgba(0,0,0,0.3);
    &:hover {
      opacity: 1;
    }
  }
`;

const Wrapper = styled.div`
  position: relative;
  /* 편집 모드일 때 윤곽선을 보여줄 수도 있습니다. */
  ${props => props.isEditMode && `
    &:hover {
      outline: 2px dashed #007bff;
      cursor: pointer;
    }
  `}
`;

const EditableObjectHandle = (props) => {
  const { id, objects, defaultObjects, intl, componentTitle, children } = props;
  const builderContext = useBuilder();
  const { isEditMode, selectComponent } = builderContext || {};

  const handleEditClick = useCallback((e) => {
    e.stopPropagation(); // 부모로 이벤트 전파 방지
    selectComponent({
      id,
      objects,
      defaultObjects,
      componentTitle
    });
  }, [id, objects, defaultObjects, componentTitle, selectComponent]);

  // isAdmin prop은 이제 BuilderContext의 isEditMode로 대체되거나 함께 사용될 수 있습니다.
  // 여기서는 isEditMode가 켜져있을 때만 버튼을 노출합니다.

  if (!isEditMode) {
    // 편집 모드가 아닐 때는 children(실제 컴포넌트 UI)을 그대로 렌더링하거나 null 반환
    // 이 컴포넌트가 HOC처럼 쓰이지 않고 단순히 내부에 삽입되는 형태라면 null 반환이 맞습니다.
    // 하지만 보통 이런 핸들러는 relative 포지션의 부모 안에 위치하므로 null을 반환합니다.
    return null;
  }

  return (
    <EditButtonContainer>
      <button 
        type="button" 
        className="btn btn-primary btn-sm"
        onClick={handleEditClick}
      >
        {intl.formatMessage({ id: 'common.edit' })} {componentTitle}
      </button>
    </EditButtonContainer>
  );
};

EditableObjectHandle.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  objects: PropTypes.object,
  defaultObjects: PropTypes.object,
  isAdmin: PropTypes.bool, // Legacy prop
  componentTitle: PropTypes.string,
  intl: PropTypes.object
};

export default injectIntl(EditableObjectHandle);
